module.exports = __webpack_public_path__ + "img/multi-claimer.6d2ceb8d.svg";